import { useState, useEffect } from "react";
import {db,storage} from '../../config/Firebase'
import { Link } from 'react-router-dom'
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import {
  Table,
  Col,
  Button,
  Image,
  Modal,
  Container,
  Card,
  Form,
  ProgressBar,
} from 'react-bootstrap'
import { useAdmin } from "../../contexts/AdminContext";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from 'firebase/storage'

const Suppliers = () => 
{
  const [loading, setLoading] = useState(false)
  const [supplierModal, setSupplierModal] = useState()
  const [SuppliertoSave, setSuppliertoSave] = useState({})
  const {suppliers} = useAdmin()


  const  addSupplier = async () => {
    setSupplierModal(true)
  };
  const handleSavesupplier = async (e) => {
    e.preventDefault()
    if (SuppliertoSave.id) {
      try {
        setLoading(true)
        await updateDoc(doc(db, 'suppliers', SuppliertoSave.id), {
          ...SuppliertoSave,
        })
        alert('Supplier Updated Successfully')
      } catch (error) {
        alert(error)
      }
    } else {
      try {
        const findDup = suppliers.filter((supplier) => supplier.name === SuppliertoSave.name)
        findDup.length > 0
          ? alert('Duplicate Name - Cannot add a supplier with same name')
          : await addDoc(collection(db, 'suppliers'), {
              ...SuppliertoSave,
            })
      } catch (error) {
        alert(error)
      }
    }
    setLoading(false)
    setSuppliertoSave({})
    setSupplierModal(false)
  }
  const updatesupplier = async (id,email,mobile,Address1,Address2,postcode,role) => {
    const supplierDoc = doc(db, "suppliers", id);
    const newFields = { email:email,mobile:mobile,Address1:Address1,Address2:Address2,postcode:postcode,role:role };
    await updateDoc(supplierDoc, newFields);
  };
 
  const deletesupplier = async (supplier) => {
    const supplierDoc = doc(db, "suppliers", supplier.id);
    console.log(supplier.id);
    await deleteDoc(supplierDoc);
  };

   return (
    <>
      Manage Customers
      <Col sm={10}>
        Do you want to add a new supplier?{' '}
        <Button
          style={{
            padding: '1px',
            borderRadius: '30px',
            margin: '1px',
            width: '60px',
          }}
          onClick={() => {
            addSupplier()
          }}
        >
          ADD
        </Button>
      </Col>
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Address1</th>
            <th>Address2</th>
            <th>Postcode</th>
            <th>Role</th>
            <th>Edit?</th>
          </tr>
        </thead>
        {suppliers &&
          suppliers.map((supplier) => (
            <tbody key={supplier.id}>
              <tr>
              <td>
                   {supplier.name}
                </td>
                <td>
                   {supplier.email}
                </td>
                <td>
                  {supplier.mobile}
                </td>
                <td>{supplier.Address1}</td>
                <td>
                  {supplier.Address2}
                </td>
                <td>
                   {supplier.postcode}
                </td>
                <td>
                  {supplier.role}
                </td>
               
                <td>
                  <Button
                    style={{
                      padding: '1px',
                      borderRadius: '30px',
                      margin: '1px',
                      width: '60px',
                    }}
                    onClick={() => {
                      setSuppliertoSave(supplier)
                      setSupplierModal(true)
                    }}
                  >
                    Edit{' '}
                  </Button>{' '}
                  <Button
                    variant='danger'
                    style={{
                      padding: '1px',
                      borderRadius: '30px',
                      margin: '1px',
                      width: '60px',
                    }}
                    onClick={async () => await deletesupplier(supplier)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            </tbody>
          ))}
      </Table>
      <Modal
        show={supplierModal}
        onHide={() => {
          setSuppliertoSave({})
          setSupplierModal(false)
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Container
          className='d-flex align-items-center justify-content-center'
          style={{ minHeight: '60vh' }}
        >
          <div className='w-100' style={{ maxWidth: '400px' }}>
            <Card>
              <Card.Body>
                <h2 className='text-center mb-4'>
                  {SuppliertoSave && SuppliertoSave.id
                    ? 'Update supplier'
                    : 'New supplier'}
                </h2>
               
                <br />
                <Form onSubmit={handleSavesupplier}>
                  <Form.Group id='name'>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Name'
                      defaultValue={SuppliertoSave && SuppliertoSave.name}
                      onChange={(e) =>
                        setSuppliertoSave({ ...SuppliertoSave, name: e.target.value })
                      }
                    />
                  </Form.Group>
                  <Form.Group id='desc'>
                    <Form.Control
                      type='email'
                      required
                      placeholder='Email'
                      defaultValue={SuppliertoSave && SuppliertoSave.email}
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          email: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  <Form.Group id='desc'>
                    <Form.Control
                      type='phone'
                      required
                      placeholder='Mobile'
                      defaultValue={SuppliertoSave && SuppliertoSave.mobile
                      }
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          mobile: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  <Form.Group id='desc'>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Address1'
                      defaultValue={SuppliertoSave && SuppliertoSave.Address1}
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          Address1: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  <Form.Group id='desc'>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Address2'
                      defaultValue={SuppliertoSave && SuppliertoSave.Address2}
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          Address2: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  <Form.Group id='desc'>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Postcode'
                      defaultValue={SuppliertoSave && SuppliertoSave.postcode}
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          postcode: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  <Form.Group id='desc'>
                    <Form.Control
                      type='text'
                      required
                      placeholder='Role'
                      defaultValue={SuppliertoSave && SuppliertoSave.role}
                      onChange={(e) =>
                        setSuppliertoSave({
                          ...SuppliertoSave,
                          role: e.target.value,
                        })
                      }
                    />
                  </Form.Group>{' '}
                  
                  <Button disabled={loading} className='w-100' type='submit'>
                    {/* <Button className='w-100' type='submit'> */}
                    {SuppliertoSave && SuppliertoSave.id ? 'Update' : 'Save'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </div>
        </Container>
      </Modal>
    </>
  )
      
      
  
  
  
  
  
}

export default Suppliers